import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from '../../components/modal/Modal';
import { GTMService } from '../../services/gtm.service';
import { VouchersService } from '../../services/vouchers.service';
import { InvitesService } from '../../services/invites.service';
import { StorageService } from '../../services/storage.service';
import { Voucher } from '../../interfaces/voucher';

@Component({
  selector: 'voucher-alert-modal',
  styleUrls: ['./voucher-alert-modal.component.scss'],
  providers: [VouchersService, InvitesService, StorageService],
  template: `
    <modal #modal [backdrop]="true" [closeOnOutsideClick]="true" (onClose)="saveAlertOptions()">
      <modal-content>
        <div class="voucher-alert">

          <img src="assets/shared/img/invitation.png" alt="Voucher liberado">

          <div class="title">Voucher liberado</div>

          <div class="description">
            O Voucher de R$ {{voucherProvider?.amount}} para usar no {{voucherProvider?.name}} está esperando por você!
          </div>

          <button class="btn" (click)="redirectToVouchers()">Ver voucher</button>
          <button class="btn link" (click)="closeModal()">Agora não</button>

        </div>
      </modal-content>
    </modal>
  `
})
export class VoucherAlertModalComponent implements OnInit {
  @ViewChild('modal')
  modal: Modal;

  @Input()
  vouchers: Voucher[] = [];

  @Input()
  voucherProvider: any;

  @Input()
  inviteAccepts = 0;

  constructor(
    private gtm: GTMService,
    private router: Router,
    private vouchersService: VouchersService,
    private invitesService: InvitesService,
    private storage: StorageService,
  ) { }

  ngOnInit() {
    this.checkVoucherAvailability();
  }

  checkVoucherAvailability() {
    const newVouchers = this.vouchers.filter(voucher => voucher.new);
    const voucherOptions = this.storage.get('voucherOptions');

    this.vouchersService.canGenerate().subscribe(({canGenerateVoucher}) => {
      const canGenerate = voucherOptions
        ? this.inviteAccepts !== voucherOptions.lastInviteAccepts && canGenerateVoucher
        : canGenerateVoucher;

      if (newVouchers.length || canGenerate) {
        this.modal.open();
      }
    });
  }

  redirectToVouchers() {
    this.modal.close();
    this.saveAlertOptions();
    this.gtm.interaction('allya:mgm', 'modal:mgm-parabens:click', 'ver-voucher');
    this.router.navigate(['/vouchers']);
  }

  closeModal() {
    this.saveAlertOptions();
    this.gtm.interaction('allya:mgm', 'modal:mgm-parabens:click', 'agora-nao');
    this.modal.close();
  }

  saveAlertOptions() {
    const ids = this.vouchers.filter(voucher => voucher.new).map(({id}) => id);
    this.vouchersService.setVoucherView(ids).subscribe();

    this.storage.set('voucherOptions', {
      lastInviteAccepts: this.inviteAccepts
    });
  }
}
